<template>
  <div class="grid">
    <establishment-form
      :establishment-id="purchaseOrderDetails.Dealer.EstablishmentID"
      :unloading-location-id="purchaseOrderDetails.ShippingLocation.ShippingLocationID"
      @change-establishment-id="onChangeEstablishmentId"
      @change-unloading-location="onChangeUnloadingLocation"
    />
    <order-information-form
      :car-amount="Number(purchaseOrderDetails.Car.Amount)"
      :remark="purchaseOrderDetails.Remark"
      :car-statuses="carStatuses"
      @change-car-amount="onChangeCarAmount"
      @change-remark="onChangeRemark"
    />
    <dispo-note
      :purchase-order-id="purchaseOrderId"
      :purchase-order-reference="purchaseOrderDetails.OrderReference"
      @change-dispo-note="onChangeDispoNote"
    />
    <div></div>
    <customer-type :is-purchase-order-page="true" />
    <div></div>
    <customer-block :customer="purchaseOrderDetails.Customer" />
  </div>
</template>

<script>
import CustomerBlock from '@/components/purchaseOrder/presentational/organisms/newCustomerSearch/CustomerBlock.vue'
import EstablishmentForm from '@/components/purchaseOrder/presentational/molecules/establishmentForm/EstablishmentForm.vue'
import OrderInformationForm from '@/components/purchaseOrder/presentational/molecules/orderInformationForm/OrderInformationForm.vue'
import DispoNote from '@/components/purchaseOrder/presentational/molecules/dispoNote/DispoNote.vue'
import CustomerType from '@/components/generic/presentational/organisms/customerType/CustomerType.vue'

export default {
  components: {
    CustomerBlock,
    EstablishmentForm,
    OrderInformationForm,
    DispoNote,
    CustomerType,
  },
  props: {
    purchaseOrderDetails: {
      type: Object,
      default: () => {},
    },
    purchaseOrderId: {
      type: String,
      default: '',
    },
    carStatuses: {
      type: Array,
      default: null,
    },
  },
  methods: {
    onChangeUnloadingLocation(data) {
      this.$store.commit('purchaseOrder/setUnloadingLocation', data)
    },
    onChangeEstablishmentId(data) {
      this.$store.commit('purchaseOrder/setEstablishmentId', data)
    },
    onChangeCarAmount(data) {
      this.$store.commit('purchaseOrder/setCarAmount', data)
    },
    onChangeRemark(data) {
      this.$store.commit('purchaseOrder/setRemark', data)
    },
    onChangeDispoNote(data) {
      this.$store.commit('purchaseOrder/setDispoNote', data)
    },
  },
}
</script>

<style lang="scss" scoped>
.grid {
  display: grid;
  grid-gap: 1em;
  grid-template-columns: 1fr 1fr;
}
</style>
